import Vue from "vue";
import App from "./App.vue";
// 常量
import OutConst from "./customEventOutConst.js";
import InConst from "./customEventInConst.js";
import CONSTNAME from "@/ConstName.js";
Vue.prototype.$outConst = OutConst;
Vue.prototype.$inConst = InConst;
Vue.prototype.$const = CONSTNAME;
/* polyfill */
/* import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill(); // 平缓滚动 */

// 全局·组件 + 过滤器
import "element-ui/lib/theme-chalk/index.css";
import components from "./global/components";
Vue.use(components);
import filters from "./global/filters";
Vue.use(filters);
import directive from "./global/directives";
Vue.use(directive);

import vco from "v-click-outside";
Vue.use(vco);
// Mock
process.env.NODE_ENV == "development" && require("@/mock/mock.js");
// import "./mock/mock.js";

import axios from "axios";
Vue.prototype.$axios = axios;
// Vuex
import createStore from "./store/index.js";
/* Dayjs时间API插件 */
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"; // const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
dayjs.extend(isSameOrBefore);
import WeekDay from "dayjs/plugin/weekday";
dayjs.extend(WeekDay);
import IsLeapYear from "dayjs/plugin/isLeapYear";
dayjs.extend(IsLeapYear);
import WeekOfYear from "dayjs/plugin/weekOfYear";
dayjs.extend(WeekOfYear);
import RelativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(RelativeTime);
Vue.prototype.$dayjs = dayjs;
import html2canvas from "html2canvas";
// import html2canvas from "@/utils/html2canvas.js";
Vue.prototype.$html2canvas = html2canvas;
// 全局·工具方法
import * as utils from "@/utils/ganttUnit.js";
Vue.prototype.$utils = utils;
import chaining from "@/utils/chaining";
Vue.use(chaining);
// mock打印图片
// import printBase64 from "./mock/mock_printBase64";

// 右菜单
import Contextmenu from "vue-contextmenujs";
Vue.use(Contextmenu);


// 组件信息(1.1.0 二零二一年五月迭代二开始)
import { name, version, description, subDesc, iteration, author, lastTime } from "../package.json";
console.log(
  `名称: %c${name}`,
  "color:red;font-weight:bold;",
  `\n版本: ${version}\n功能: ${description}\n附加: ${subDesc}\n迭代: ${iteration}\n开发: ${author}\n环境: ${process.env.NODE_ENV}\n时间: ${lastTime}`,
);

/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
// eslint-disable-next-line no-unexpected-multiline
(function(KDApi) {
  function MyComponent(model, props) {
    this._setModel(model);
  }

  // 判断时间轴跨度
  const checkTimes = function(start, end, type, msg, vm) {
    const nextCount = dayjs(end).diff(dayjs(start), type);
    if (nextCount > 15000) {
      vm && vm.$Message({
        message: msg, // "跨度过大, 请切换视图方案 时间标尺单位!",
        type: "error",
        showClose: true,
      });
      // 或者Todo提示后端
      return false;
    }
    return true;
  };
  // 重置HTML滚动和事件
  const resetHtml = function(id) {
    const ganttNode = document.getElementById(id);
    if (ganttNode) {
      ganttNode.onmousemove = null;
      // 重置滚动位置
      const scrollNodes = ganttNode.getElementsByClassName("scroll-list-container"); // nomal-list-container infinite-list-container
      for (let i = 0; i < scrollNodes.length; i++) {
        scrollNodes[i].scrollTop = 0;
        console.log("重置回顶", i);
      }
    }
  };

  // 交互响应
  const callBack = function(model, props, _store) {
    _store.commit("set_theme", props.themeNum); // 主题色
    const paramsMap = props.data;
    if (
      (!paramsMap && typeof paramsMap != "object") ||
      paramsMap == null ||
      paramsMap.success !== true
    ) {
      return _store.state.dataLoadingStatus && _store.commit("set_dataLoadingStatus", false); // 关闭数据加载态;
    }
    const action = paramsMap.methodName;
    console.log("平台返回数据:", paramsMap);
    const _uuid = model.pageId + "_" + model.key;
    const _vm = window[_uuid];
    if (action == InConst.DATA_LOADING) { // 初始化·主动发起数据加载
      _store.commit("set_dataLoadingStatus", true);
      return _store.dispatch(OutConst.CUSTOM_INIT);

    } else if (action == InConst.INIT_APP) { // 初始化·刷新数据
      // 时间轴最大跨度限制
      const _start = paramsMap.viewSchem.start;
      const _end = paramsMap.viewSchem.end || Date.now();
      const newCellUnitType = paramsMap.viewSchem.cellUnitType;
      const msg = paramsMap.langMap.timeExceedMsg || _store.state.langMap.timeExceedMsg;
      if (checkTimes(_start, _end, newCellUnitType, msg, _vm)) {
        // 重置全局监听事件-连接指示虚线移动
        (!paramsMap.stayInPlace) && resetHtml(_uuid);
        _store.commit("initGantt", paramsMap);
      }
    } else if (action == InConst.LOAD_CONTENT) { // 加载分批内容
      _store.commit("loadContent", paramsMap.data);
    } else if (action == InConst.UPDATE_CONTENT) { // 局部更新内容
      _store.commit("updateContent", paramsMap.data);
    } else if (action == InConst.BIGER_CELLSCALE) { // ***放大·时间单元格尺寸显示比例***
      _store.dispatch(
        "changeCellScale",
        {
          type: "biger",
          // scale: 100,
        },
      );
    } else if (action == InConst.SMALLER_CELLSCALE) { // ***缩小·时间单元格尺寸显示比例***
      _store.dispatch(
        "changeCellScale",
        {
          type: "small",
          // scale: 100,
        },
      );
    } else if (action == InConst.CHANG_SHOW_MODE) { // ***切换整体视图模式·左中右***
      _store.commit("changeShowMode", paramsMap.showMode);
    } else if (action == InConst.UPDATE_ROWS) { // 刷新行集合(选中状态及内容都可)
      _store.commit("setwbsRowArr", paramsMap.pageData.dataList);
    } else if (action == InConst.SET_CELLSCALE) { // ***设置时间轴单元格缩放比例***
      // const newScale = paramsMap.scale;
      // _store.dispatch(
      //   "changeCellScale",
      //   {
      //     type: "setScale",
      //     scale: newScale,
      //   },
      // );
    } else if (action == InConst.SET_CELLTYPE) { // 设置时间轴单元格类型["hour", "day", "week", "month"]
      // 时间轴最大跨度限制
      const _start = _store.state.viewSchem.start;
      const _end = _store.state.viewSchem.end || Date.now();
      const newCellUnitType = paramsMap.cellUnitType;
      const msg = _store.state.langMap.timeExceedMsg;
      if (checkTimes(_start, _end, newCellUnitType, msg, _vm)) {
        _store.commit("setCellUnitType", newCellUnitType);
      }
    } else if (action == InConst.SET_TIMELINESHOWROWS) { // 设置时间轴单元格类型·几行
      const timelineShowRows = paramsMap.viewSchem.timelineShowRows;
      _store.commit("set_timelineShowRows", timelineShowRows);
    } else if (action == InConst.SET_CELLSTARTANDEND) { // 设置时间轴起止
      // 时间轴最大跨度限制
      const start = paramsMap.viewSchem.start;
      const end = paramsMap.viewSchem.end;
      const cellUnitType = _store.state.cellUnitType;
      const msg = _store.state.langMap.timeExceedMsg;
      if (checkTimes(start, end, cellUnitType, msg, _vm)) {
        _store.commit("set_cellStartAndEnd", { start, end });
      }
    } else if (action == InConst.GET_PRINT) { // ***打印[全部, 当前屏]***
      const pars = {
        "printType": paramsMap.printType, // 1: 全部 2: 当前屏
        _vm,
      };
      _store.dispatch("_sendPrintInfo", pars);
    } else if (action == InConst.CANCEL_PRINT) { // ***取消打印·重置打印状态***
      _store.commit("set_printStatus", false);
    } else if (action == InConst.ADD_ROW) { // ***新增行***

    } else if (action == InConst.DEL_ROW) { // ***删除行***

    } else if (action == InConst.UPDATE_EXPAND_STATUS) { // 刷新展开节点信息
      _store.commit("updateMainData", paramsMap);
    } else if (action == InConst.UPDATE_SELECT_STATUS) { // 选中·刷新树列表节点信息
      const { item } = paramsMap;
      _store.commit("set_selectStatus_item", { ganttType: item.ganttType, id: item.id, status: item.isSelect });
    } else if (action == InConst.UPDATE_TASKS) { // 刷新横道集合
      _store.dispatch("gtRefreshTasks", paramsMap);
    } else if (action == InConst.UPDATE_GANTT_DATA) { // 刷新某个区域集合
      _store.commit("updateMainData", paramsMap);
    } else if (action == InConst.EXCHANGE_GANTT_DATA) { // 交换·更新2个区域集合
      _store.commit("exchangeMainData", paramsMap);
    } else if (action == InConst.UPDATE_SELECTSTATUS_AREA) { // 更新单区域全部选中行集合
      _store.commit("set_selectStatus_area", paramsMap);
    } else if (action == InConst.UPDATE_LINES_STATUS) { // ***更新 连线是否显示开关***
      _store.commit("set_isLineShow", paramsMap.isLineShow);
    } else if (action == InConst.UPDATE_TIMELINESHOWROWS) { // ***更新 时间轴内容显示几级***
      _store.commit("set_timelineShowRows", paramsMap.isLineShow);
    } else if (action == InConst.UPDATE_RANKMODE_STATUS) { // ***更新 时间轴·自增排序显示开关***
      _store.commit("set_isRankMode", paramsMap.isRankMode);
    } else if (action == InConst.UPDATE_WEEKCODEMODE_STATUS) { // ***更新 时间轴·周几首字母显示开关***
      _store.commit("set_isWeekCodeMode", paramsMap.isWeekCodeMode);
    } else if (action == InConst.UPDATE_VERTICALMODE_STATUS) { // ***更新 时间轴二级菜单是否竖直显示开关***
      _store.commit("set_isVerticalMode", paramsMap.isVerticalMode);
    } else if (action == InConst.UPDATE_EMPTYBARS_STATUS) { // ***更新 是否显示空白横道开关***
      _store.commit("set_emptyBarsShow", paramsMap.emptyBarsShow);
    } else if (action == InConst.UPDATE_NORMALBARS_STATUS) { // ***更新 是否显示正常横道开关***
      _store.commit("set_normalBarsShow", paramsMap.normalBarsShow);
    } else if (action == InConst.UPDATE_TASKFILTER_3_STATUS) { // ***更新 横道显示筛选·关键路径横道***
      _store.commit("set_taskFilter3", paramsMap.taskFilter3);
    } else if (action == InConst.UPDATE_TASKFILTER_6_STATUS) { // ***更新 横道显示筛选·二级关键路径横道***
      _store.commit("set_taskFilter6", paramsMap.taskFilter6);
    } else if (action == InConst.UPDATE_TASKBORDERRADIUS_STATUS) { // ***更新 常规任务横道是否不显示圆角***
      _store.commit("set_noTaskBorderRadiusShow", paramsMap.isTaskBorderShow);
    } else if (action == InConst.UPDATE_TASKBORDER_STATUS) { // ***更新 常规任务横道是否显示黑色边框***
      _store.commit("set_isTaskBorderShow", paramsMap.isTaskBorderShow);
    } else if (action == InConst.UPDATE_ROWCHECKBOX_STATUS) { // ***更新 表单行是否显示勾选框***
      _store.commit("set_isRowCheckBoxShow", paramsMap.isRowCheckBoxShow);
    } else if (action == InConst.UPDATE_ROWICON_STATUS) { // ***更新 表单行是否显示名称前置图标***
      _store.commit("set_isRowIconShow", paramsMap.isRowIconShow);
    } else if (action == InConst.UPDATE_WEEKEDBG_STATUS) { // ***更新 是否显示非工作日背景***
      _store.commit("set_weekedBgShow", paramsMap.weekedBgShow);
    } else if (action == InConst.UPDATE_TREEFONTSIZE) { // ***更新 树结构显示 字体大小***
      _store.commit("set_treeFontSize", paramsMap.treeFontSize);
    } else if (action == InConst.UPDATE_TREEFONTWEIGHT) { // ***更新 树结构显示 字体加粗***
      _store.commit("set_treeFontWeight", paramsMap.treeFontWeight);
    } else if (action == InConst.UPDATE_NOGANTTOUTBOXBORDER) { // ***更新 无甘特图外边框***
      _store.commit("set_noGanttOutBoxBorder", paramsMap.noGanttOutBoxBorder);
    } else if (action == InConst.UPDATE_ISBARSELECTROW) { // ***更新 选择横道是否选中所属行***
      _store.commit("set_isBarSelectRow", paramsMap.isBarSelectRow);
    } else if (action == InConst.UPDATE_ISPRINTMODESHOW) { // ***更新 是否打印显示模式(不限高·平铺计划区)***
      _store.commit("set_isPrintModeShow", paramsMap.isPrintModeShow);
    } else if (action == InConst.UPDATE_PRINTMODEWIDTH) { // ***更新 打印预览模式尺寸比·宽***
      _store.commit("set_printModeWidth", paramsMap.printModeWidth);
    } else if (action == InConst.UPDATE_PRINTMODEHEIGHT) { // ***更新 打印预览模式尺寸比·高***
      _store.commit("set_printModeHeight", paramsMap.printModeHeight);
    } else if (action == InConst.UPDATE_PRINTMODESIZE) { // 更新 同时修改打印预览模式尺寸比·宽+高
      _store.commit("set_printModeSize", paramsMap.viewSchem);
    } else if (action == InConst.UPDATE_BARSFONTSIZE) { //  ***更新 巴条标签文字大小***
      _store.commit("set_barsFontSize", paramsMap);
    } else if (action == InConst.UPDATE_TIMELINEWEEKCODESHOWNUMS) { //  ***更新 时间轴周字母显示数量***
      _store.commit("set_timelineWeekCodeShowNums", paramsMap);
    } else if (action == InConst.UPDATE_TIMELINEFONTNOMAL) { //  ***更新 时间轴字体大小正常显示***
      _store.commit("set_timeLineFontNomal", paramsMap);
    } else if (action == InConst.UPDATE_TIMESLINEHEIGHT) { //  ***更新 时间轴·单行行高***
      _store.commit("set_timesLineHeight", paramsMap);
    } else if (action == InConst.UPDATE_CELLHEIGHT) { //  ***更新 横道区·单元行高***
      _store.commit("set_cellHeight", paramsMap);
    } else if (action == InConst.UPDATE_TIMELINEFONTSIZE) { //  ***更新 时间轴·字体大小***
      _store.commit("set_timelineFontSize", paramsMap.data.timelineFontSize);
    } else if (action == InConst.UPDATE_LINKLINECOLOR) { //  更新 连线关系·颜色
      _store.commit("set_linkLineColor", paramsMap.data.linkLineColor);
    } else if (action == InConst.UPDATE_TIMELINEBGDATES) { //  更新 展示背景色日期·集合
      _store.commit("set_timelineBgDates", paramsMap.data.timelineBgDates);
    } else if (action == InConst.UPDATE_TIMELINEBGDATESCOLOR) { //  更新 展示背景色日期·背景颜色值
      _store.commit("set_timelineBgDatesColor", paramsMap.data.timelineBgDatesColor);
    } else if (action == InConst.UPDATE_VIEW_CONFIG) { // 更新视图通用项内配置
      _store.commit("set_viewSchem", paramsMap.viewSchem);
    } else if (action == InConst.UPDATE_SUMMARY) { // 设置统计区显示数据及开关
      _store.commit("set_summary", paramsMap.info);
    } else if (action == InConst.UPDATE_GANTT_WIDTH) { // ***更新 甘特图整体容器尺寸·宽度
      _store.commit("setGanttWidth", paramsMap.ganttWidth);
    } else if (action == InConst.UPDATE_GANTT_HEIGHT) { // ***更新 甘特图整体容器尺寸·高度
      _store.commit("setGanttHeight", paramsMap.ganttHeight);
    } else if (action == InConst.INIT_SEARCHEDLIST) { // ***初始化·搜索横道结果集合***
      _store.dispatch("showSearchedTaskInit", paramsMap.searchedList);
    } else if (action == InConst.UPDATE_SEARCHEDACTNUM) { // ***更新展示搜索横道结果集合下标***
      _store.dispatch("showSearchedTaskActNum", paramsMap.searchedActNum);
    } else if (action == InConst.CLOSE_SEARCHEDLIST) { // ***关闭·重置搜索横道结果集合***
      _store.dispatch("hideSearchedTask");
    }
    _store.state.dataLoadingStatus && _store.commit("set_dataLoadingStatus", false); // 关闭数据加载态
    // model.invoke(OutConst.RESET_STATUS, model.schemaId);
    console.log("u指令结束");

  };

  /* 监听容器 */
  function addResizeObserve(element, callback) {
    const handleResize = (entries) => {
      const entry = entries[0];
      const { width, height } = entry.contentRect;
      const hide = width === 0 && height === 0;
      const rect = { hide, width, height };
      // console.log("entry.target", entry.target);
      callback && callback(rect);
    };
    let watcher = new ResizeObserver(handleResize);
    watcher.observe(element);
    return {
      removeResizeObserve: function() {
        watcher.disconnect(element);
        watcher = null;
      },
    };
  }

  if (KDApi) {
    const setHtml = (model) => {
      const { dom } = model;
      const _uuid = model.pageId + "_" + model.key;

      window[_uuid] = new Vue({
        el: dom,
        data: {
          resizeObj: null,
        },
        created() {
          this.$store.commit("setUuid", _uuid);
        },
        components: { App },
        template: `<App />`,
        methods: {
          resizeCb(info) {
            if (
              info.hide === true ||
              info.width == this.$store.state.ganttWidth ||
              this.$store.state.printStatus ||
              this.$store.state.viewSchem.isPrintModeShow
            ) {
              return; // console.log("Fit ignore", info.hide === true, info.width == this.$store.state.ganttWidth, this.$store.state.printStatus, this.$store.state.viewSchem.isPrintModeShow);
            }
            const { width, height } = info;
            this.$store.commit("setGanttWidth", width);
            this.$store.commit("setGanttHeight", height);
          },
        },
        store: window["_store_" + _uuid],
        mounted() {
          // console.log("初始化容器宽");
          this.resizeObj = addResizeObserve(this.$el.parentNode, this.resizeCb);
        },
        beforeDestroy() {
          if (this.resizeObj && this.resizeObj.removeResizeObserve) {
            this.resizeObj.removeResizeObserve();
            this.resizeObj = null;
          }
        },

      });
    };
    const toolsInfoStyle1 = "color:#fadfa3;font-weight:bold;background:#030307;padding:5px;";
    const toolsInfoStyle2 = "color:#FFFFFF;font-weight:bold;background:green;padding:5px;";
    const toolsInfoStyle3 = "color:#0000ff;font-weight:bold;background:pink;padding:5px;";
    MyComponent.prototype = {
      _setModel: function(model) {
        this.model = model;
        const _uuid = model.pageId + "_" + model.key;
        const _storeKey = "_store_" + _uuid;
        if (KDApi) {
          window[_storeKey] = createStore();
        } else {
          window[_storeKey] = createStore();
        }

        this.store = window[_storeKey];
        window[_storeKey]._invoke = function() {
          return model.invoke(arguments[0], arguments[1]);
        };
        window[_storeKey]._invokeAsync = function() {
          return model.invokeAsync(arguments[0], arguments[1]);
        };
        const _langMap = {
          dragErrorMsg: KDApi.getLangMsg(this.model, "dragErrorMsg"),
          timeExceedMsg: KDApi.getLangMsg(this.model, "timeExceedMsg"),
          dayOption: KDApi.getLangMsg(this.model, "dayOption"),
          hourOption: KDApi.getLangMsg(this.model, "hourOption"),
          weekOption: KDApi.getLangMsg(this.model, "weekOption"),
          monthOption: KDApi.getLangMsg(this.model, "monthOption"),
          cellScaleText: KDApi.getLangMsg(this.model, "cellScaleText"),
          realCellScaleText: KDApi.getLangMsg(this.model, "realCellScaleText"),
          cellWidthText: KDApi.getLangMsg(this.model, "cellWidthText"),
          setScaleText: KDApi.getLangMsg(this.model, "setScaleText"),
          magnifyText: KDApi.getLangMsg(this.model, "magnifyText"),
          shrinkText: KDApi.getLangMsg(this.model, "shrinkText"),
          printText: KDApi.getLangMsg(this.model, "printText"),
          batchSelectText: KDApi.getLangMsg(this.model, "batchSelectText"),
          timelineText: KDApi.getLangMsg(this.model, "timelineText"),
          newScaleText: KDApi.getLangMsg(this.model, "newScaleText"),
          startSearchText: KDApi.getLangMsg(this.model, "startSearchText"),
          preSearchText: KDApi.getLangMsg(this.model, "preSearchText"),
          nextSearchText: KDApi.getLangMsg(this.model, "nextSearchText"),
          closeSearchText: KDApi.getLangMsg(this.model, "closeSearchText"),
        };
        window[_storeKey].commit("set_lang", _langMap);
        window[_storeKey].commit("set_ganttName", KDApi.getLangMsg(this.model, "ganttName"));
      },
      init: function(props) {
        window.common_gantt_initStamp = Date.now();
        console.log(`init:%c${name}%c${description}`, toolsInfoStyle1, toolsInfoStyle3, this.model, props, window.common_gantt_initStamp);
        KDApi.loadFile(["src/css/app.css"], this.model, () => {
          const model = this.model;
          setHtml(model);
        });
      },
      update: function(props) {
        window.common_gantt_initStamp = Date.now();
        const model = this.model;
        console.log(`update:%c${name}%c${version}%c${lastTime}`, toolsInfoStyle1, toolsInfoStyle2, toolsInfoStyle3, this.model, props, window.common_gantt_initStamp);

        callBack(model, props, this.store);
      },
      destoryed: function() {
        delete window.common_gantt_initStamp;
        console.log(`destoryed:%c${name}%c${version}%c${lastTime}`, toolsInfoStyle1, toolsInfoStyle2, toolsInfoStyle3, this.model, Date.now());

        const _uuid = this.model.pageId + "_" + this.model.key;
        window[_uuid] = null;
        window["_store_" + _uuid] = null;
        this.store = null;
      },
    };

    // 注册自定义组件
    KDApi.register(name, MyComponent, {
      isMulLang: true,
    });
  } else {

    const _now = Date.now();
    const model = {
      timestamp: _now,
      pageId: "mockPageId-" + _now,
      key: "ganttctl",
      dom: "#app",
      desc: "mock model " + _now,
    };
    // 添加本地实现平台内效果特殊处理方案
    const invoke = function(event, arg, exArg, _store) {
      console.log(`苍穹调用:\n方法名: ${event} \n参数: ${(typeof arg === "object" ? JSON.stringify(arg) : arg + "").substring(0, 900)}`);
      if (event == OutConst.ADD_CROSSLINE) {
        console.log("本地·新增连线关系", arg, exArg, _store);
        const { obj, starPosObj, tasksArr = _store.state[CONSTNAME.PLANS + "_tasksArr"], ganttType } = exArg;
        const _index = starPosObj.taskListIndex; // starPosObj._selfIndex;
        const newArr = tasksArr; // utils.deepClone(tasksArr);
        newArr[_index].taskLink = [obj];
        _store.dispatch("gtRefreshTasks", {
          arr: newArr,
          ganttType,
        });

      } else if (event == OutConst.START_PRINT && arg.base64) {
        console.log("本地·打印: 本地测试查看生成图片");
        const img = new Image();
        img.src = arg.base64;
        const newWin = window.open("", "_blank");
        if (newWin) {
          newWin.document.write(img.outerHTML);
          newWin.document.title = "打印图片";
          newWin.document.close();
        }

      } else if (event == OutConst.DEL_ROW) {
        console.log("本地·右键删除WBS内容单行");
        const item = arg;
        window[_uuid].$MessageBox.confirm(`本地·删除任务: ${arg.name}?`, "确认删除", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        })
          .then((action) => {
            _store.commit("deleteWBS", {
              index: exArg.index,
              item,
            });
          })
          .catch((action) => {

          });

      } else if (event == OutConst.ADJUST_TASK) {
        console.log("本地·拖拽|调整 更新横道位置");
        const { item, targetGanttType } = arg;
        if (item.ganttType === targetGanttType) {
          console.log("拖拽修改区域数据", arg);
          _store.commit("changeOldTask", arg);
        }
      }
    };
    const _uuid = model.pageId + "_" + model.key;
    const _storeKey = "_store_" + _uuid;
    if (KDApi) {
      window[_storeKey] = createStore(KDApi.getLangMsg(this.model, "ganttName"));
    } else {
      window[_storeKey] = createStore("名称");
    }
    window[_storeKey]._invoke = invoke;

    // 实例化
    window.common_gantt_initStamp = Date.now();
    const { dom } = model;
    window.kd = window[_uuid] = new Vue({
      el: dom,
      data: {
        resizeObj: null,
      },
      created() {
        const _self = this;
        _self.$axios({
          method: "post",
          url: "/api/initGantt_cq1",
          // url: "/api/initGantt_cq2",
          // url: "/api/initGantt_cq3",
          data: {},
        })
          .then((res) => {
            if (res.data.success === true) {
              console.log("Mock:", res);
              _self.$store.commit("setUuid", _uuid);
              _self.$store.commit("initGantt", res.data);

              // 重置全局监听事件-连接指示虚线移动
              const ganttNode = document.getElementById(_uuid);
              if (ganttNode) {
                ganttNode.onmousemove = null;
              }
              // setTimeout(() => {
              //   _self.$store.dispatch("loadMockCq", 2);
              // }, 3000);
            }
          });
      },
      components: { App },
      template: `<App />`,
      methods: {
        resizeCb(info) {
          if (
            info.hide === true ||
            info.width == this.$store.state.ganttWidth ||
            this.$store.state.printStatus ||
            this.$store.state.viewSchem.isPrintModeShow
          ) {
            return;
          }
          const { width, height } = info;
          this.$store.commit("setGanttWidth", width);
          this.$store.commit("setGanttHeight", height);
        },
      },
      store: window[_storeKey],
      mounted() {
        // console.log("初始化容器宽");
        this.resizeObj = addResizeObserve(this.$el.parentNode, this.resizeCb);
      },
      beforeDestroy() {
        if (this.resizeObj && this.resizeObj.removeResizeObserve) {
          this.resizeObj.removeResizeObserve();
          this.resizeObj = null;
        }
      },

    });

  }

})(window.KDApi);
